<ng-container *ngIf="state.multipleAssetsWithSameIdentifier === false">
    <app-asset-information-content-modal class="ion-page" [state]="state">
    </app-asset-information-content-modal>
</ng-container>
<ng-container *ngIf="state.multipleAssetsWithSameIdentifier === true">
    <app-asset-type-selection-modal class="asset-type-selection">
    </app-asset-type-selection-modal>
</ng-container>